import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SgToastService } from '@sg/ui-kit/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SgGeneralErrorComponent } from '../components';
import { EnvironmentService } from './environment.service';

const ErrorStatusesToCatch = [400, 500, 404, 405];

const SKIP_GLOBAL_ERROR_HEADER = 'sgSkipGlobalError';

/**
 * Header object to suppress global error toast display.
 * Use this when you want to handle errors locally (e.g., showing an error state in the UI).
 *
 * @example
 * // With generated API clients:
 * this.apiClient.someMethod(params, { observe: 'body', headers: SKIP_GLOBAL_ERROR });
 *
 * // With HttpClient directly:
 * this.http.get('/api/data', { headers: new HttpHeaders(SKIP_GLOBAL_ERROR) });
 */
export const SKIP_GLOBAL_ERROR = { [SKIP_GLOBAL_ERROR_HEADER]: 'true' };

@Injectable()
export class SgHttp500Interceptor implements HttpInterceptor {
  constructor(
    private dialog: MatDialog,
    private environmentService: EnvironmentService,
    private toastService: SgToastService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('sgAsyncGuiPlugin')) {
      return next.handle(req);
    }

    if (req.headers.has(SKIP_GLOBAL_ERROR_HEADER)) {
      const cleanedReq = req.clone({ headers: req.headers.delete(SKIP_GLOBAL_ERROR_HEADER) });

      return next.handle(cleanedReq);
    }

    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (ErrorStatusesToCatch.includes(error.status)) {
            switch (this.environmentService.branding.generalErrorContainerType) {
              case 'dialog':
                this.displayDialog();
                break;
              case 'toaster':
                this.displayToaster();
                break;
            }
          }
        }
        return throwError(error);
      })
    );
  }

  private displayDialog() {
    this.dialog.open(SgGeneralErrorComponent, {
      minWidth: 510,
      disableClose: true,
      backdropClass: 'sg-backdrop',
      panelClass: 'sg-popup-massage-container',
    });
  }

  private displayToaster() {
    this.toastService.error({
      title: 'Error',
      description: this.environmentService.branding.generalErrorMessage,
    });
  }
}
